import { getJwtSelect } from '@gymaholic/packages/src/modules/jwt/selectors'
import { APP_OPTION } from 'constants/app'

const queryString = require('query-string')

function getEndpointUtil (pathname) {
  return API_ENDPOINT + pathname
}

export function prepareOptionsApiUtil (options, state) {
  const trainingJwt = getJwtSelect(state)
  const trainingJwtOption = options && options[APP_OPTION.TRAINING_JWT]
  // logUtil('prepareOptionsApiUtil').debug('[start]')
  const newOptions = {
    ...(
      options || {}
    )
  }
  if (DEVELOPMENT && !trainingJwtOption) {
    newOptions[APP_OPTION.TRAINING_JWT] = trainingJwt
    // logUtil('prepareOptionsApiUtil').debug('adding trainingJwt')
  }
  return newOptions
}

export function getHeadersAndEndpointApiUtil (endpoint, options = {}) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }

  // logUtil('getHeadersAndEndpointApiUtil').debug('[start]')
  const jwt = options && options[APP_OPTION.JWT]
  if (jwt && endpoint.startsWith(API_ENDPOINT)) {
    // logUtil('getHeadersAndEndpointApiUtil').debug('adding jwt')
    headers.Authorization = `Bearer ${jwt}`
  }

  const trainingJwt = options && options[APP_OPTION.TRAINING_JWT]
  if (trainingJwt && endpoint.startsWith(TRAINING_API_ENDPOINT)) {
    // logUtil('getHeadersAndEndpointApiUtil').debug('adding trainingJwt')
    headers.Authorization = `Bearer ${trainingJwt}`
  }

  const trainingJti = options && options[APP_OPTION.TRAINING_JTI]
  if (trainingJti && endpoint.startsWith(TRAINING_API_ENDPOINT)) {
    const {
      url,
      query
    } = queryString.parseUrl(endpoint)
    query.trainingJti = trainingJti
    endpoint = url + `?${queryString.stringify(query)}`
    // logUtil('getHeadersAndEndpointApiUtil').debug('adding trainingJti')
  }

  return {
    headers,
    endpoint
  }
}

export default getEndpointUtil
